<template>
  <div style="width: 100%;">
    <el-upload class="avatar-uploader" :action="uploadAction" :show-file-list="false" :on-success="handleSuccess">
      <img v-if="form[name]" :src="$store.state.common.systemInfo.fileurl + form[name]" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon">
        <el-icon><UploadFilled /></el-icon>
      </i>
    </el-upload>
  </div>
</template>

<script>
import { getUploadUrl } from '@/utils/upload';

export default {
  props: {
    form: { type: Object },
    name: String,
    fieldname: String,
  },
  computed: {
    uploadAction() { return getUploadUrl('image'); },
  },
  methods: {
    handleSuccess(res) {
      if (this.form) this.form[this.name] = res.data;
    },
  },
};
</script>